import { useAuth } from "../contexts/AuthContext";

/**
 * Returns the Okta Bearer token string for authenticated API requests.
 * Undefined when Okta is not configured (local dev without Okta).
 */
export function useAuthBearer(): string | undefined {
  const { oktaAuth } = useAuth();
  const token = oktaAuth?.getAccessToken();
  return token ? `Bearer ${token}` : undefined;
}
